<template>
  <div class="add-box">
    <!-- 顶部导航栏区域 start -->
    <div class="header sticky">
      <span class="back-img" @click="previousPage"></span>
      <span class="page-title">大宗/危废录入</span>
      <span class="quit" @click="islogout">退出</span>
    </div>
    <!-- 顶部导航栏区域 end -->
    <!-- 录入按钮区域 start -->
    <div class="grid-box">
      <van-grid :column-num="3" :gutter="10">
        <van-grid-item
          v-for="item in gridList"
          :key="item.id"
          :class="item.className"
          :icon="item.icon"
          :text="item.text"
          @click="goNextEnteringPage(item.url)"
        />
      </van-grid>
    </div>
    <!-- 录入按钮区域 end -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      gridList: [
        {
          id: 1,
          icon: "add",
          text: "大宗录入",
          url: "/BulkTypeIn",
          className: "bulk",
        },
        {
          id: 2,
          icon: "add",
          text: "危废录入",
          url: "/WasteTypeIn",
          className: "waste",
        },
      ],
    };
  },
  methods: {
    // 跳转页面
    goNextEnteringPage(url) {
      this.$router.push(url);
    },
    // 返回上页
    previousPage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-box {
  width: 100vw;
  height: 100vh;
  .header {
    height: 50px;
    color: azure;
    background-color: cadetblue;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 999;
    .back-img {
      margin-left: 10px;
      width: 28px;
      height: 28px;
      background-image: url(../../assets/u39.png);
      background-size: 100%;
    }
    .quit {
      margin-right: 10px;
    }
  }
}
.sticky {
  position: sticky;
  top: 0px;
}
.grid-box {
  padding: 10px 0;
  .bulk {
    height: 120px;
    ::v-deep .van-grid-item__text {
      font-size: 18px;
      font-weight: bold;
    }
    ::v-deep .van-grid-item__icon {
      color: #07c160;
    }
  }
  .waste {
    height: 120px;
    ::v-deep .van-grid-item__text {
      font-size: 18px;
      font-weight: bold;
    }
    ::v-deep .van-grid-item__icon {
      color: #ff976a;
    }
  }
  ::v-deep .van-grid-item__content--center {
    border: 2px solid #07c160;
    border-radius: 10px;
  }
}
</style>
